import { Modal, Box, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";

interface WordViewerModalProps {
  wordUrl: string; // URL of the Word document
  open: boolean;
  onClose: () => void;
}

const WordViewerModal: React.FC<WordViewerModalProps> = ({
  wordUrl,
  open,
  onClose,
}) => {
  // Use Google Docs Viewer to render the Word document
  const googleDocsViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(wordUrl)}&embedded=true`;

  // Use Microsoft Office Viewer instead of Google Docs Viewer
  const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(wordUrl)}`;

  // Function to handle downloading the Word document
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = wordUrl;
    link.setAttribute("download", "document.docx"); // Set the download filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          position: "relative",
          width: "95%",
          height: "98%",
          backgroundColor: "white",
          boxShadow: 24,
        }}
      >
        <iframe
          title="Word viewer"
          src={officeViewerUrl}
          width="93%"
          height="100%"
          frameBorder="0"
        />
        {/* Container for Close and Download buttons */}
        <Box
          sx={{
            position: "absolute",
            top: 20,
            right: 40,
            display: "flex",
            flexDirection: "column",
            gap: 3, // Adds spacing between the buttons
          }}
        >
          {/* Close Button */}
          <Tooltip title={"Close the Word document"}>
            <IconButton
              onClick={onClose}
              sx={{
                backgroundColor: "red",
                color: "#ffffff",
                fontWeight: 600,
                borderRadius: 15,
                "&:hover": {
                  backgroundColor: "#333333",
                },
                textTransform: "none",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
          {/* Download Button */}
          <Tooltip title={"Download the Word document"}>
            <IconButton
              onClick={handleDownload}
              sx={{
                backgroundColor: "primary.main",
                color: "#ffffff",
                fontWeight: 600,
                borderRadius: 15,
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
                textTransform: "none",
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Modal>
  );
};

export default WordViewerModal;
